import React from "react";
import { ArrowUpOutlined, ArrowDownOutlined, MinusOutlined } from "@ant-design/icons";

const InventoryComparisonColumnModel = () => {
  const modelArr: any[] = [];

  // 当前月份日期
  modelArr.push({
    title: "Current Month",
    field: "currentMonthDate",
    editable: "never",
    render: (rowData: any) => {
      const date = rowData.currentMonthDate;
      return date ? new Date(date).toLocaleDateString("en-NZ", { year: 'numeric', month: 'long' }) : '-';
    }
  });

  // 上月日期
  modelArr.push({
    title: "Previous Month",
    field: "previousMonthDate",
    editable: "never",
    render: (rowData: any) => {
      const date = rowData.previousMonthDate;
      return date ? new Date(date).toLocaleDateString("en-NZ", { year: 'numeric', month: 'long' }) : '-';
    }
  });

  // 总库存金额对比
  modelArr.push({
    title: "Total Value",
    field: "totalValue",
    editable: "never",
    render: (rowData: any) => {
      const metric = rowData.totalValue;
      if (!metric) return '-';

      const isPositive = metric.changePercent > 0;
      const isNegative = metric.changePercent < 0;
      const isNeutral = metric.changePercent === 0;

      const arrowIcon = isPositive ? (
        <ArrowUpOutlined style={{ color: "#cf1322", marginRight: 4 }} />
      ) : isNegative ? (
        <ArrowDownOutlined style={{ color: "#389e0d", marginRight: 4 }} />
      ) : (
        <MinusOutlined style={{ color: "#8c8c8c", marginRight: 4 }} />
      );

      const changeColor = isPositive ? "#cf1322" : isNegative ? "#389e0d" : "#8c8c8c";

      return (
        <div>
          <div style={{ fontWeight: "bold", fontSize: 16 }}>
            ${metric.currentMonthValue?.toFixed(2) || "0.00"}
          </div>
          <div style={{ fontSize: 12, color: "#8c8c8c", marginTop: 4 }}>
            Prev: ${metric.previousMonthValue?.toFixed(2) || "0.00"}
          </div>
          <div style={{ fontSize: 12, marginTop: 4, color: changeColor, display: "flex", alignItems: "center" }}>
            {arrowIcon}
            <span>{isPositive ? "+" : ""}{metric.changePercent?.toFixed(2) || "0.00"}%</span>
            <span style={{ marginLeft: 8, color: "#8c8c8c" }}>
              (${isPositive ? "+" : ""}{metric.changeAmount?.toFixed(2) || "0.00"})
            </span>
          </div>
        </div>
      );
    }
  });

  // 总库存箱数对比
  modelArr.push({
    title: "Total Boxes",
    field: "totalBoxes",
    editable: "never",
    render: (rowData: any) => {
      const metric = rowData.totalBoxes;
      if (!metric) return '-';

      const isPositive = metric.changePercent > 0;
      const isNegative = metric.changePercent < 0;
      const isNeutral = metric.changePercent === 0;

      const arrowIcon = isPositive ? (
        <ArrowUpOutlined style={{ color: "#cf1322", marginRight: 4 }} />
      ) : isNegative ? (
        <ArrowDownOutlined style={{ color: "#389e0d", marginRight: 4 }} />
      ) : (
        <MinusOutlined style={{ color: "#8c8c8c", marginRight: 4 }} />
      );

      const changeColor = isPositive ? "#cf1322" : isNegative ? "#389e0d" : "#8c8c8c";

      return (
        <div>
          <div style={{ fontWeight: "bold", fontSize: 16 }}>
            {metric.currentMonthValue?.toFixed(0) || "0"} Boxes
          </div>
          <div style={{ fontSize: 12, color: "#8c8c8c", marginTop: 4 }}>
            Prev: {metric.previousMonthValue?.toFixed(0) || "0"} Boxes
          </div>
          <div style={{ fontSize: 12, marginTop: 4, color: changeColor, display: "flex", alignItems: "center" }}>
            {arrowIcon}
            <span>{isPositive ? "+" : ""}{metric.changePercent?.toFixed(2) || "0.00"}%</span>
            <span style={{ marginLeft: 8, color: "#8c8c8c" }}>
              ({isPositive ? "+" : ""}{metric.changeAmount?.toFixed(0) || "0"} Boxes)
            </span>
          </div>
        </div>
      );
    }
  });

  // Slow Moving 对比
  modelArr.push({
    title: "Slow Moving (3–12 Months)",
    field: "slowMovingValue",
    editable: "never",
    render: (rowData: any) => {
      const metric = rowData.slowMovingValue;
      if (!metric) return '-';

      const isPositive = metric.changePercent > 0;
      const isNegative = metric.changePercent < 0;
      const isNeutral = metric.changePercent === 0;

      const arrowIcon = isPositive ? (
        <ArrowUpOutlined style={{ color: "#cf1322", marginRight: 4 }} />
      ) : isNegative ? (
        <ArrowDownOutlined style={{ color: "#389e0d", marginRight: 4 }} />
      ) : (
        <MinusOutlined style={{ color: "#8c8c8c", marginRight: 4 }} />
      );

      const changeColor = isPositive ? "#cf1322" : isNegative ? "#389e0d" : "#8c8c8c";

      return (
        <div>
          <div style={{ fontWeight: "bold", fontSize: 16 }}>
            ${metric.currentMonthValue?.toFixed(2) || "0.00"}
          </div>
          <div style={{ fontSize: 12, color: "#8c8c8c", marginTop: 4 }}>
            Prev: ${metric.previousMonthValue?.toFixed(2) || "0.00"}
          </div>
          <div style={{ fontSize: 12, marginTop: 4, color: changeColor, display: "flex", alignItems: "center" }}>
            {arrowIcon}
            <span>{isPositive ? "+" : ""}{metric.changePercent?.toFixed(2) || "0.00"}%</span>
            <span style={{ marginLeft: 8, color: "#8c8c8c" }}>
              (${isPositive ? "+" : ""}{metric.changeAmount?.toFixed(2) || "0.00"})
            </span>
          </div>
        </div>
      );
    }
  });

  // Dead Stock 对比
  modelArr.push({
    title: "Dead Stock (> 12 Months, No Sales)",
    field: "deadStockValue",
    editable: "never",
    render: (rowData: any) => {
      const metric = rowData.deadStockValue;
      if (!metric) return '-';

      const isPositive = metric.changePercent > 0;
      const isNegative = metric.changePercent < 0;
      const isNeutral = metric.changePercent === 0;

      const arrowIcon = isPositive ? (
        <ArrowUpOutlined style={{ color: "#cf1322", marginRight: 4 }} />
      ) : isNegative ? (
        <ArrowDownOutlined style={{ color: "#389e0d", marginRight: 4 }} />
      ) : (
        <MinusOutlined style={{ color: "#8c8c8c", marginRight: 4 }} />
      );

      const changeColor = isPositive ? "#cf1322" : isNegative ? "#389e0d" : "#8c8c8c";

      return (
        <div>
          <div style={{ fontWeight: "bold", fontSize: 16 }}>
            ${metric.currentMonthValue?.toFixed(2) || "0.00"}
          </div>
          <div style={{ fontSize: 12, color: "#8c8c8c", marginTop: 4 }}>
            Prev: ${metric.previousMonthValue?.toFixed(2) || "0.00"}
          </div>
          <div style={{ fontSize: 12, marginTop: 4, color: changeColor, display: "flex", alignItems: "center" }}>
            {arrowIcon}
            <span>{isPositive ? "+" : ""}{metric.changePercent?.toFixed(2) || "0.00"}%</span>
            <span style={{ marginLeft: 8, color: "#8c8c8c" }}>
              (${isPositive ? "+" : ""}{metric.changeAmount?.toFixed(2) || "0.00"})
            </span>
          </div>
        </div>
      );
    }
  });

  // 客户专版对比
  modelArr.push({
    title: "Customer Specific",
    field: "customerSpecificValue",
    editable: "never",
    render: (rowData: any) => {
      const metric = rowData.customerSpecificValue;
      if (!metric) return '-';

      const isPositive = metric.changePercent > 0;
      const isNegative = metric.changePercent < 0;
      const isNeutral = metric.changePercent === 0;

      const arrowIcon = isPositive ? (
        <ArrowUpOutlined style={{ color: "#cf1322", marginRight: 4 }} />
      ) : isNegative ? (
        <ArrowDownOutlined style={{ color: "#389e0d", marginRight: 4 }} />
      ) : (
        <MinusOutlined style={{ color: "#8c8c8c", marginRight: 4 }} />
      );

      const changeColor = isPositive ? "#cf1322" : isNegative ? "#389e0d" : "#8c8c8c";

      return (
        <div>
          <div style={{ fontWeight: "bold", fontSize: 16 }}>
            ${metric.currentMonthValue?.toFixed(2) || "0.00"}
          </div>
          <div style={{ fontSize: 12, color: "#8c8c8c", marginTop: 4 }}>
            Prev: ${metric.previousMonthValue?.toFixed(2) || "0.00"}
          </div>
          <div style={{ fontSize: 12, marginTop: 4, color: changeColor, display: "flex", alignItems: "center" }}>
            {arrowIcon}
            <span>{isPositive ? "+" : ""}{metric.changePercent?.toFixed(2) || "0.00"}%</span>
            <span style={{ marginLeft: 8, color: "#8c8c8c" }}>
              (${isPositive ? "+" : ""}{metric.changeAmount?.toFixed(2) || "0.00"})
            </span>
          </div>
        </div>
      );
    }
  });

  return modelArr;
};

export default InventoryComparisonColumnModel;
